/**
 * Runtime configuration for the frontend application.
 * Values are populated at build time via Vite environment variables,
 * with fallback placeholders that can be replaced at deployment time.
 */

export interface AppConfig {
  // DVV Cognito configuration (magic link users)
  VITE_AMPLIFY_REGION: string;
  VITE_AMPLIFY_USER_POOL_ID: string;
  VITE_AMPLIFY_APP_CLIENT_ID: string;
  VITE_IDENTITY_POOL_ID: string;
  VITE_API_URL: string;

  // WoningNet SSO configuration
  VITE_SSO_ENABLED: string;
  VITE_SSO_USER_POOL_ID: string;
  VITE_SSO_APP_CLIENT_ID: string;
  VITE_SSO_REGION: string;
  VITE_SSO_DOMAIN: string;
  VITE_SSO_REDIRECT_URL: string;

  // Sentry configuration
  VITE_SENTRY_DSN: string;
  VITE_SENTRY_ENVIRONMENT: string;
  VITE_SENTRY_TRACES_SAMPLE_RATE: string;
  VITE_SENTRY_RELEASE: string;
}

const config: AppConfig = {
  // DVV Cognito configuration
  VITE_AMPLIFY_REGION:
    import.meta.env.VITE_AMPLIFY_REGION ||
    '<AWS_COGNITO_REGION_FILL_AT_DEPLOYMENT>',
  VITE_AMPLIFY_USER_POOL_ID:
    import.meta.env.VITE_AMPLIFY_USER_POOL_ID ||
    '<AWS_COGNITO_USER_POOL_ID_FILL_AT_DEPLOYMENT>',
  VITE_AMPLIFY_APP_CLIENT_ID:
    import.meta.env.VITE_AMPLIFY_APP_CLIENT_ID ||
    '<AWS_COGNITO_CLIENT_ID_FILL_AT_DEPLOYMENT>',
  VITE_IDENTITY_POOL_ID:
    import.meta.env.VITE_IDENTITY_POOL_ID ||
    '<AWS_IDENTITY_POOL_ID_FILL_AT_DEPLOYMENT>',
  VITE_API_URL:
    import.meta.env.VITE_API_URL || '<API_URL_FILL_AT_DEPLOYMENT>',

  // WoningNet SSO configuration
  VITE_SSO_ENABLED: import.meta.env.VITE_SSO_ENABLED || 'false',
  VITE_SSO_USER_POOL_ID:
    import.meta.env.VITE_SSO_USER_POOL_ID ||
    '<SSO_USER_POOL_ID_FILL_AT_DEPLOYMENT>',
  VITE_SSO_APP_CLIENT_ID:
    import.meta.env.VITE_SSO_APP_CLIENT_ID ||
    '<SSO_APP_CLIENT_ID_FILL_AT_DEPLOYMENT>',
  VITE_SSO_REGION:
    import.meta.env.VITE_SSO_REGION || 'eu-central-1',
  VITE_SSO_DOMAIN:
    import.meta.env.VITE_SSO_DOMAIN || 'sso-dta.woningnet.nl',
  VITE_SSO_REDIRECT_URL:
    import.meta.env.VITE_SSO_REDIRECT_URL ||
    '<SSO_REDIRECT_URL_FILL_AT_DEPLOYMENT>',

  // Sentry configuration
  VITE_SENTRY_DSN:
    import.meta.env.VITE_SENTRY_DSN || '<SENTRY_DSN_FILL_AT_DEPLOYMENT>',
  VITE_SENTRY_ENVIRONMENT:
    import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
  VITE_SENTRY_TRACES_SAMPLE_RATE:
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.2',
  VITE_SENTRY_RELEASE:
    import.meta.env.VITE_SENTRY_RELEASE || '<SENTRY_RELEASE_FILL_AT_DEPLOYMENT>',
};

export default config;

/**
 * Check if WoningNet SSO is enabled for this environment
 */
export const isSsoEnabled = (): boolean => config.VITE_SSO_ENABLED === 'true';
